// Centralized icon imports
import GithubIcon from "@/images/Icons/github-original.svg";
import LinkedinIcon from "@/images/Icons/linkedin-original.svg";
import HomeIcon from "@/images/Icons/icons8-home.svg";
import ResumeIcon from "@/images/Icons/resume-7.png";
import WebsiteIcon from "@/images/Icons/website.png";

// Tech Stack Icons
import JavascriptIcon from "@/images/Icons/javascript-plain.svg";
import ReactIcon from "@/images/Icons/react-original.svg";
import ReactIconDark from "@/images/Icons/react-original-dark.svg";
import ReduxIcon from "@/images/Icons/redux-original.svg";
import HTMLIcon from "@/images/Icons/html5-original.svg";
import CSSIcon from "@/images/Icons/css3-original.svg";
import FirebaseIcon from "@/images/Icons/firebase-plain-wordmark.svg";
import RubyIcon from "@/images/Icons/ruby-original-wordmark.svg";
import RailsIcon from "@/images/Icons/rails-plain-wordmark.svg";
import VueIcon from "@/images/Icons/vuejs.svg";
import TypescriptIcon from "@/images/Icons/typescript.svg";
import VuetifyIcon from "@/images/Icons/vuetify.svg";
import VueXIcon from "@/images/Icons/vuex.svg";
import TailwindIcon from "@/images/Icons/tailwind.svg";
import ZustandIcon from "@/images/Icons/zustand.svg";
import AxiosIcon from "@/images/Icons/axios.svg";
import PiniaIcon from "@/images/Icons/pinia.svg";
import QuasarIcon from "@/images/Icons/quasar.svg";
import ShadCnIcon from "@/images/Icons/shadcn.svg";
import StorybookIcon from "@/images/Icons/storybook.svg";
import GoogleCloudIcon from "@/images/Icons/google_cloud-icon.svg";
import RapidAPIIcon from "@/images/Icons/rapidapi-icon.svg";
import SupabaseIcon from "@/images/Icons/supabase.svg";
import VercelIcon from "@/images/Icons/vercel.svg";
import HerokuIcon from "@/images/Icons/heroku-original-wordmark.svg";

// Export all icons as a named object
export const Icons = {
  // Social & Navigation
  github: GithubIcon,
  linkedin: LinkedinIcon,
  home: HomeIcon,
  resume: ResumeIcon,
  website: WebsiteIcon,

  // Tech Stack Icons
  javascript: JavascriptIcon,
  react: ReactIcon,
  reactDark: ReactIconDark,
  redux: ReduxIcon,
  html: HTMLIcon,
  css: CSSIcon,
  firebase: FirebaseIcon,
  ruby: RubyIcon,
  rails: RailsIcon,
  vue: VueIcon,
  typescript: TypescriptIcon,
  vuetify: VuetifyIcon,
  vuex: VueXIcon,
  tailwind: TailwindIcon,
  zustand: ZustandIcon,
  axios: AxiosIcon,
  pinia: PiniaIcon,
  quasar: QuasarIcon,
  shadcn: ShadCnIcon,
  storybook: StorybookIcon,
  googleCloud: GoogleCloudIcon,
  rapidapi: RapidAPIIcon,
  supabase: SupabaseIcon,
  vercel: VercelIcon,
  heroku: HerokuIcon,
};

// Icon mapping for stack names
export const getStackIcon = (stack) => {
  // Handle comma-separated stacks by checking if TypeScript is mentioned
  if (stack && stack.includes("TypeScript")) {
    return Icons.typescript;
  }

  const stackMap = {
    React: Icons.reactDark,
    Vue: Icons.vue,
    Ruby: Icons.ruby,
    Javascript: Icons.javascript,
    JavaScript: Icons.javascript,
    TypeScript: Icons.typescript,
  };
  return stackMap[stack] || Icons.javascript;
};

// Export individual icons for backward compatibility
export {
  GithubIcon,
  LinkedinIcon,
  HomeIcon,
  ResumeIcon,
  WebsiteIcon,
  JavascriptIcon,
  ReactIcon,
  ReactIconDark,
  ReduxIcon,
  HTMLIcon,
  CSSIcon,
  FirebaseIcon,
  RubyIcon,
  RailsIcon,
  VueIcon,
  TypescriptIcon,
  VuetifyIcon,
  VueXIcon,
  TailwindIcon,
  ZustandIcon,
  AxiosIcon,
  PiniaIcon,
  QuasarIcon,
  ShadCnIcon,
  StorybookIcon,
  GoogleCloudIcon,
  RapidAPIIcon,
  SupabaseIcon,
  VercelIcon,
  HerokuIcon,
};
